// extracted by mini-css-extract-plugin
export default {"wrapper":"HorseList_wrapper__KvMyu"};